import React, { useState } from 'react';
import { useNavigate, useLocation } from "react-router-dom";
import { useAuth } from "../../login/AuthProvider";
import axios from "axios";
import { backend } from '../../../components/apipath';

const Form = () => {
    const { setAuth } = useAuth();
    const navigate = useNavigate();
    const location = useLocation();

    // 登入身分：employee = 老師/管理員, partner = 合作夥伴
    const [loginRole, setLoginRole] = useState("employee");
    const [account, setAccount] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");

    // 把各種型態的錯誤統一轉成「字串」
    const extractErrorMessage = (err) => {
        let msg = "登入失敗，請確認帳號與密碼";

        const data = err?.response?.data;
        if (!data) return msg;

        // 如果後端直接回字串
        if (typeof data === "string") return data;

        // 有 errors 欄位的情況（可能是物件）
        if (data.errors) {
            if (typeof data.errors === "string") return data.errors;

            if (typeof data.errors === "object" && data.errors !== null) {
                // 例如：{ account: ["帳號錯誤"], password: ["密碼錯誤"] }
                const first = Object.values(data.errors).flat()[0];
                if (typeof first === "string") return first;
            }
        }

        // 有 msg 欄位
        if (typeof data.msg === "string") return data.msg;

        return msg;
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setError("");

        if (!account.trim() || !password.trim()) {
            setError("請輸入帳號與密碼");
            return;
        }

        console.log("🔍 submit loginRole =", loginRole);

        // ======================
        // ① 內部人員登入（老師/管理員）
        // ======================
        if (loginRole === "employee") {
            try {
                // 1) 建立 session
                await axios.post(`${backend}login/employee`, {
                    account: account.trim(),
                    password: password.trim(),
                }, {
                    withCredentials: true
                });

                // 2) 用 checkAuth 確認身分
                const res = await axios.get(`${backend}login/checkAuth`, {
                    withCredentials: true
                });

                if (res.data?.authorized && (res.data.type === 'admin' || res.data.type === 'teacher')) {
                    const authData = {
                        ...res.data,
                        authorized: true,
                    };

                    setAuth(authData);
                    localStorage.setItem("authAdm", JSON.stringify(authData));

                    const params = new URLSearchParams(location.search);
                    const redirect = params.get("redirect") || "/adm/admh";
                    navigate(redirect);
                } else {
                    setError("您無後台權限");
                }
            } catch (err) {
                console.error(err);
                const msg = extractErrorMessage(err);
                setError(msg);  // ✅ 保證是字串
            }
            return; // ❗ 員工這條結束就回傳，不要往下
        }

        // ======================
        // ② 合作夥伴登入（partner）
        // ======================
        if (loginRole === "partner") {
            try {
                const res = await axios.post(`${backend}partner/login`, {
                    account: account.trim(),
                    password: password.trim(),
                });

                const data = res.data;
                console.log("partner login response", data);

                if (!data.success || !data.authorized || data.type !== "partner") {
                    setError(data.msg || "合作夥伴帳號或密碼錯誤");
                    return;
                }

                const authData = {
                    authorized: true,
                    id: data.id || 0,
                    mem_id: data.mem_id || 0,
                    partner_id: data.partner_id || 0,
                    account: data.account || account,
                    token: data.token || "partner-token", // 非空字串，方便初始化判斷
                    name: data.name || "",
                    type: data.type || "partner",
                    chinese_name: data.chinese_name || "",
                    mem_status: data.mem_status ?? "",
                };

                setAuth(authData);
                localStorage.setItem("authAdm", JSON.stringify(authData));

                navigate("/adm/partner");
            } catch (err) {
                console.error(err);
                const msg = extractErrorMessage(err);
                setError(msg);
            }
        }
    };

    return (
        <form id="form" onSubmit={handleSubmit}>
            <h2 className='mb-4'>Direct Line 後台登入</h2>

            {/* 身分切換按鈕 */}
            <div className="btn-group mb-4" role="group" aria-label="login role">
                <button
                    type="button"
                    className={`btn btn-sm ${loginRole === "employee" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => {
                        setLoginRole("employee");
                        setError("");
                    }}
                >
                    內部人員（老師 / 管理員）
                </button>
                <button
                    type="button"
                    className={`btn btn-sm ${loginRole === "partner" ? "btn-primary" : "btn-outline-primary"}`}
                    onClick={() => {
                        setLoginRole("partner");
                        setError("");
                    }}
                >
                    合作夥伴登入
                </button>
            </div>

            <div>
                <label htmlFor="account">帳號</label>
                <input
                    className='form-control'
                    type="text"
                    id="account"
                    name="account"
                    value={account}
                    onChange={(e) => setAccount(e.target.value)}
                    required
                />
            </div>

            <div>
                <label className='mt-4' htmlFor="password">密碼</label>
                <input
                    className='form-control'
                    type="password"
                    id="password"
                    name="password"
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    required
                />
            </div>

            {error && (
                <div id="error" className="text-danger mt-3">
                    {error} {/* ✅ 這裡一定是字串，不會再是物件 */}
                </div>
            )}

            <input className='btn btn-primary mt-4' type="submit" value="登入" />
        </form>
    );
};

export default Form;
